// Dependencies
import { createContext } from "react";

const FetchSpinner = createContext();

export default FetchSpinner;
